import ButtonContent from './component';

export default ButtonContent;
